import { FC } from 'react';
import { A11yButton } from '@fe-learner-common';
import { useSessionDisenrollment } from '@hooks/mutations/useSessionDisenrollment';
import { useIntl } from 'react-intl';
import { useDisenrollmentFeedback } from '@routes/session-details/hooks/useDisenrollmentFeedback';
import { useError } from '@hooks/useError';

type DisenrollButtonProps = {
  sessionId: number;
  disabled: boolean;
};

export const DisenrollButton: FC<DisenrollButtonProps> = ({
  sessionId,
  disabled,
}) => {
  const intl = useIntl();
  const emitError = useError();

  const {
    mutate: disenroll,
    data: disenrollmentData,
    error,
    isPending,
  } = useSessionDisenrollment({
    sessionId,
  });

  emitError({
    error: error,
    errorMapOverride: {
      type: 'modal',
    },
  });

  useDisenrollmentFeedback({ disenrollmentStatus: disenrollmentData?.status });

  return (
    <A11yButton
      disabled={disabled}
      className="l-btn l-btn-md l-btn-secondary"
      isLoading={isPending}
      onClick={() => {
        disenroll();
      }}
    >
      {intl.formatMessage({ id: 'catalog.course.action.disenroll' })}
    </A11yButton>
  );
};
